// Application-wide constants
export const SUPPORT_EMAIL = "support@ompnt.com"
